<template>
  <div>
    <div class="page-modal">
      <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
        :title="'新建-' + typeName" :has-form="true" class="my-test-class" @close="close" @confirm="handleConfirm">
        <div class="page-form">
          <gs-form ref="form" class="form" label-width="50px" label-position="left" gap="small">
            <gs-form-item label="名称" prop="name" class="form-item-name">
              <gs-input ref="nameInput" v-model="name" type="text" />
            </gs-form-item>
          </gs-form>
        </div>
      </gs-modal>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
export default {
  components: {

  },
  data() {
    return {
      loading: false,
      name: ''
    }
  },
  computed: {
    ...mapState({
      visible: 'addFolderDialog',
      nodeData: 'objectInfo'
    }),
    typeName() {
      let type = this.$store.state.type
      switch (type) {
        case 'project':
          return '项目组'
        case 'folder':
          return '文件夹'
        case 'server':
          return '项目'
        case 'logicalGroup':
          return '逻辑组'
        case 'deviceGroup':
          return '设备组'
        default:
          break
      }
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.name = ''
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    ...mapMutations({
      close: 'FOLDER_HIDE',
      needReload: 'NEED_RELOAD_TREE'
    }),
    beforeClose() {
      this.close()
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      this.loading = true
      let data = {
        attribute: null,
        children: [],
        description: '',
        name: this.name,
        parentId: this.nodeData.id,
        type: this.$store.state.type
      }
      service.newAddPoint(data).then(res => {
        this.name = ''
        this.loading = false
        this.$Message.success('新建成功')
        this.close()
        this.$store.state.addTreeNode = res
      }).catch(err => {
        this.loading = false
        this.$Message.error(err.message)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/left-side/addFolder.vue